import './Spinners.scss';
export const RedirectSpinner = () => <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>;